var appConstants = {
    MEDIAPATH: '/img',
    CLIENTID: 'pub' //This is configured in the API
}

export default appConstants;



// WEBPACK FOOTER //
// ./web-app/constants/app-constants.js